import {
  MockCard,
  MockButton,
  MockSearchInput,
  MockSelect,
  MockLink,
  MockInput,
} from '../../components/mockups/MockUI'
import { MockStatusBadge } from '../../components/mockups/MockBadge'
import { MockTable, MockAgGridHeader } from '../../components/mockups/MockTable'

export function RequestsList() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Список заявок
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Страница «Заявки» — таблица всех ваших заявок. Открывается через пункт меню «Заявки».
          MANAGER видит только свои заявки, ADMIN — все.
        </p>
      </div>

      <MockCard>
        <div className="flex items-center justify-between mb-3">
          <span className="text-lg font-semibold text-gray-900 dark:text-gray-100">Заявки</span>
          <MockButton>+ Новая заявка</MockButton>
        </div>
        <div className="flex items-center gap-2">
          <MockSearchInput placeholder="Поиск по таблице..." />
          <MockSelect label="" value="Все статусы" />
        </div>
      </MockCard>

      <MockTable
        caption="Пример таблицы заявок"
        columns={[
          { header: 'Клиент' },
          { header: 'Заявка' },
          { header: 'Тип' },
          { header: 'Дедлайн' },
          { header: 'Статус' },
          { header: 'Позиций' },
          { header: 'Сумма КП' },
          { header: 'Создана' },
        ]}
        rows={[
          [
            <MockLink>ООО «Электросервис»</MockLink>,
            <MockLink>17.04.26-3</MockLink>,
            'Текучка',
            <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-red-100 text-red-700">
              18.04.26
            </span>,
            <MockStatusBadge status="IN_PROGRESS" />,
            '24',
            '—',
            '17.04.26',
          ],
          [
            <MockLink>АО «ТехноПром»</MockLink>,
            <MockLink>17.04.26-2</MockLink>,
            'Проект',
            <span className="text-gray-700 dark:text-gray-300">25.04.26</span>,
            <MockStatusBadge status="NEW" />,
            '8',
            '—',
            '16.04.26',
          ],
          [
            <MockLink>ИП Сидоров</MockLink>,
            <MockLink>15.04.26-1</MockLink>,
            'Текучка',
            <span className="text-gray-400">—</span>,
            <MockStatusBadge status="QUOTATION_READY" />,
            '3',
            '85 000 ₽',
            '15.04.26',
          ],
        ]}
      />

      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">
            Дедлайн — цветовая индикация:
          </div>
          <ul className="space-y-1 list-none">
            <li>
              <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-red-100 text-red-700 select-none">
                18.04.26
              </span>{' '}
              — просрочена (дата прошла)
            </li>
            <li>
              <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-amber-100 text-amber-700 select-none">
                19.04.26
              </span>{' '}
              — осталось ≤3 дня
            </li>
            <li>
              <span className="text-gray-700 dark:text-gray-300">25.04.26</span> — нормальный срок
            </li>
          </ul>
        </div>
      </MockCard>
    </div>
  )
}

export function RequestsNew() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Создание заявки
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Кнопка «+ Новая заявка» на странице заявок. Форма состоит из двух частей: основная
          информация и парсер позиций.
        </p>
      </div>

      <MockCard className="max-w-lg">
        <div className="text-base font-medium text-gray-900 dark:text-gray-100 mb-4">
          Новая заявка
        </div>
        <div className="space-y-3">
          <MockSelect label="Клиент *" value="ООО «Электросервис»" />
          <MockSelect label="Тип" value="Текучка" />
          <MockInput label="Дедлайн" value="25.04.2026" />
          <MockInput label="Заметки" placeholder="Комментарий к заявке..." />
        </div>
      </MockCard>

      <MockCard>
        <div className="text-base font-medium text-gray-900 dark:text-gray-100 mb-3">
          Парсер позиций
        </div>
        <div className="space-y-3">
          <div className="px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg text-sm bg-gray-50 dark:bg-gray-700 text-gray-500 dark:text-gray-400 min-h-[80px] select-none">
            Вставьте текст с позициями...
            <br />
            Например:
            <br />
            STM32F103C8T6 ST 100шт
            <br />
            MAX232 Maxim 50
          </div>
          <p className="text-xs text-gray-500 dark:text-gray-400">
            Система автоматически распознает партномер, бренд и количество. Нераспознанные строки
            подсвечиваются оранжевым — их можно исправить вручную.
          </p>
        </div>
      </MockCard>

      <MockTable
        caption="Распознанные позиции"
        columns={[
          { header: '✓' },
          { header: 'Партномер' },
          { header: 'Бренд' },
          { header: 'Кол-во' },
          { header: 'Статус' },
        ]}
        rows={[
          [
            '✅',
            'STM32F103C8T6',
            'ST',
            '100',
            <span className="text-green-600 text-xs">Распознано</span>,
          ],
          [
            '✅',
            'MAX232',
            'Maxim',
            '50',
            <span className="text-green-600 text-xs">Распознано</span>,
          ],
          [
            '⚠️',
            'ABCD123???',
            '—',
            '—',
            <span className="text-amber-600 text-xs">Требует проверки</span>,
          ],
        ]}
      />

      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">Как работает парсер:</div>
          <ol className="list-decimal list-inside space-y-1">
            <li>Вставьте текст из письма, Excel, WhatsApp или любой таблицы</li>
            <li>Система разбирает каждую строку на партномер, бренд, количество</li>
            <li>Бренд автоматически сопоставляется со справочником (топ-100 производителей)</li>
            <li>Зелёные строки готовы, оранжевые — нужно проверить</li>
            <li>Нажмите «Создать заявку» — позиции создаются bulk-запросом</li>
          </ol>
        </div>
      </MockCard>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">
            Drag-and-drop порядка позиций:
          </div>
          <p>
            Распознанные строки можно перетаскивать мышью за иконку слева — заданный порядок
            сохранится при создании заявки. Удобно когда нужно поставить ключевые компоненты в
            начало списка, чтобы закупщик увидел их первыми.
          </p>
        </div>
      </MockCard>
    </div>
  )
}

export function RequestsDetail() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Страница заявки
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Открывается при клике на заявку. Содержит заголовок, таблицу позиций, панель действий и
          историю.
        </p>
      </div>

      <MockCard>
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center gap-3">
            <span className="text-xs text-gray-500 dark:text-gray-400">← Заявки</span>
            <span className="text-lg font-semibold text-gray-900 dark:text-gray-100">
              17.04.26-3
            </span>
            <MockStatusBadge status="IN_PROGRESS" />
          </div>
          <div className="flex gap-2">
            <MockButton variant="secondary">Редактировать</MockButton>
            <MockButton variant="secondary">Копировать</MockButton>
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 text-xs text-gray-500 dark:text-gray-400 mt-3">
          <div>
            Клиент:{' '}
            <span className="font-medium text-gray-800 dark:text-gray-200">
              ООО «Электросервис»
            </span>
          </div>
          <div>
            Тип: <span className="font-medium text-gray-800 dark:text-gray-200">Текучка</span>
          </div>
          <div>
            Дедлайн: <span className="font-medium text-red-600">18.04.26</span>
          </div>
          <div>
            Менеджер:{' '}
            <span className="font-medium text-gray-800 dark:text-gray-200">Иванов П.</span>
          </div>
        </div>
      </MockCard>

      <MockAgGridHeader
        columns={[
          '↗',
          'Партномер',
          'Бренд',
          'Матрица',
          'Кол-во',
          'Статус',
          'Приоритет',
          'Склад',
          'Китай',
          'РФ',
          'Произв.',
          'Заметка',
        ]}
      />

      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">Ключевые элементы:</div>
          <ul className="space-y-1 list-disc list-inside">
            <li>
              <span className="font-medium">№</span> — нумерация позиций в порядке создания
            </li>
            <li>
              <span className="font-medium">↗</span> — стрелочка перехода на страницу позиции
            </li>
            <li>
              <span className="font-medium">Матрица</span> — источник: Склад, Китай, РФ,
              Производители, Стоки
            </li>
            <li>
              <span className="font-medium">Колонки цен</span> — заполняются закупщиками, менеджер
              видит readonly
            </li>
            <li>
              <span className="font-medium">Чекбоксы</span> — выбор позиций для массовых действий
              (удаление, назначение)
            </li>
            <li>
              <span className="font-medium">Редактирование</span> — партномер, бренд, заметка
              кликаются и редактируются прямо в таблице
            </li>
          </ul>
        </div>
      </MockCard>
      <MockCard>
        <div className="text-sm text-gray-600 dark:text-gray-400 space-y-2">
          <div className="font-medium text-gray-800 dark:text-gray-200">
            Дополнительные блоки на странице заявки:
          </div>
          <ul className="space-y-1 list-disc list-inside">
            <li>
              <span className="font-medium">Статус просчёта закупки</span> — видно, какие закупщики
              отметили заявку завершённой и сколько позиций ещё в работе
            </li>
            <li>
              <span className="font-medium">Комментарии</span> — общая лента к заявке, поддерживает
              многострочный ввод и @-упоминания (символ @ откроет список доступных пользователей)
            </li>
            <li>
              <span className="font-medium">КП и снапшоты</span> — история сформированных
              коммерческих предложений с датами и итоговыми суммами
            </li>
          </ul>
        </div>
      </MockCard>
    </div>
  )
}
